import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Flex, Modal, Spin, Tooltip, Typography } from "antd";
import React, { useState } from "react";
import { PageHeader } from "../../../../components/page-header";
import { AddPositionModal } from "./AddPositionModal";
import { usePosition } from "./usePosition";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { useGetDataOnScroll } from "../../../../components/getDataOnScrollProps/useGetDataOnScrollProps";
import { useLazyGetPositionsListQuery } from "../../../../redux/api/handBooksApi/positionsApi";
import { EntPositions } from "../../../../models/handBooks/positions";
import { ContentPartFilter } from "../../../../components/content-part/ContentPartFilter";
import { FilterPosition } from "./FilterPosition";
import _ from "lodash";
import { EntPositionFilter } from "../../../../models/filters/positionFilter";
import { useForm } from "antd/es/form/Form";

enum FormField {
  name,
  departmentIds,
  governmentId
}

export const Positions = () => {

  const [form] = useForm();
  const { t } = useTranslation()
  const [modal, contextHolder] = Modal.useModal();
  const [selectedPosition, setSelectedPosition] = useState<EntPositions>(new EntPositions());
  const [showModal, setShowModal] = useState<boolean>(false);
  const { onAddPosition, onEditPosition, onDeletePosition } = usePosition(modal, () => {
	searchHandleClick()
  })
  const [height, setHeight] = useState<number>(0);

  const [getData] = useLazyGetPositionsListQuery();
  const {
	fetching,
	data,
	access,
	filter,
	totalItems,
	setFilter,
	setData,
	setCurrentPage,
	setFetching
  } = useGetDataOnScroll<EntPositions, EntPositionFilter>({
	initialFilter: new EntPositionFilter(),
	query: getData
  });


  const openAddModal = (item: EntPositions) => {
	setSelectedPosition(item);
	setShowModal(true);
  }

  const setEntityFromFields = (): EntPositionFilter => {
	let item: EntPositionFilter = _.clone(filter);
	item.name = form.getFieldValue(FormField.name) ?? null;
	item.governmentId = form.getFieldValue(FormField.governmentId) ?? null;
	item.departmentIds = form.getFieldValue(FormField.departmentIds) ?? null;
	item.page = 1;
	return item;
  }

  const clearFields = () => {
	form.setFields([
	  { name: FormField.name, value: null },
	  { name: FormField.governmentId, value: null },
	  { name: FormField.departmentIds, value: null },
	]);
  }

  const searchHandleClick = () => {
	setFilter(setEntityFromFields());
	setData([]);
	setCurrentPage(0);
	setFetching(true);
  }

  const table = (
	<div style={ { maxHeight: `${ height }px`, overflow: 'auto' } }>
	  <table>
		<thead>
		<tr>
		  <th style={ { width: "40px" } }>#</th>
		  <th>{ t('general.name') }</th>
		  <th>{ t('titles.departments') }</th>
		  <th>{ t('titles.governments') }</th>
		  <th style={ { width: "120px" } }></th>
		</tr>
		</thead>
		<tbody>
		{ fetching ?
		  <tr>
			<th colSpan={ 5 }>
			  <Spin spinning={ fetching } style={ {
				width: '100%',
				height: '180px',
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center'
			  } }/>
			</th>
		  </tr>
		  : <></> }
		{ data.map((item, index) => (
		  <tr key={ item.id }>
			<td>{ ++index }</td>
			<td>{ i18n.language === 'ru' ? item.nameRu : item.nameKy }</td>
			<td>{ i18n.language === 'ru' ? item.department?.nameRu : item.department?.nameKy }</td>
			<td>{ i18n.language === 'ru' ? item.department?.government?.nameRu : item.department?.government?.nameKy }</td>
			<td>
			  <Flex gap="small">
				{ access && access.methodPut && (
				  <Tooltip title={ t('general.edit') }>
					<Button className='btn_edit' onClick={ () => {
					  openAddModal(item)
					} } type="primary" shape="circle" icon={ <EditOutlined/> }/>
				  </Tooltip>
				) }
				{ access && access.methodDelete && (
				  <Tooltip title={ t('general.delete') }>
					<Button className='btn_edit' danger onClick={ () => {
					  onDeletePosition(item)
					} } type="primary" shape="circle" icon={ <DeleteOutlined/> }/>
				  </Tooltip>
				) }
			  </Flex>
			</td>
		  </tr>
		)) }
		</tbody>
	  </table>
	</div>
  );
  return (
	<>
	  <PageHeader
		title={ t('titles.positions') }
		additionalInfo={
		  <Typography.Text style={ { marginBottom: '0.5em', display: 'block' } }
						   type="secondary">{ t('general.records_found') } { totalItems }</Typography.Text>
		}/>
	  { access && access.methodPost && (
		<Button type="primary" icon={ <PlusOutlined/> } onClick={ () => {
		  openAddModal(new EntPositions)
		} }>
		  { t('handbooks.positions.add_position') }
		</Button>
	  ) }
	  <ContentPartFilter
		filter={ <FilterPosition onSearch={ searchHandleClick }
								 onReset={ () => {
								   clearFields();
								   searchHandleClick()
								 } } formField={ FormField } form={ form }/> }
		setHeight={ setHeight }
		table={ table }
		width={ 800 }
	  />
	  <AddPositionModal
		position={ selectedPosition }
		show={ showModal }
		onHide={ () => {
		  setShowModal(false)
		} }
		onSubmit={ selectedPosition.id !== 0 ? onEditPosition : onAddPosition }
	  />
	  { contextHolder }
	</>
  )
}
